import styled from 'styled-components';

import { styledReset } from '../styles';

export const PrimitiveInputRange = styled.input.attrs({ type: 'range' })`
    ${styledReset.inputRange};

    &:disabled {
        cursor: not-allowed;
    }
`;
